/* eslint import/prefer-default-export: "off" */
import * as React from 'react'
import { isEmpty, includes, some, filter } from 'lodash'
import MultiSelectAction from './multi.select.action'
import styles from '../data.grid.styl'
import type { GridAction, PluginProps } from '../models'
import { isDisabled } from '../helpers'

export interface ActionsPluginProps<T, PluginOptions>
  extends PluginProps<T, PluginOptions> {
  actions: GridAction<T>[]
}

function ActionsPlugin<T, PluginOptions>(
  props: ActionsPluginProps<T, PluginOptions>
) {
  const {
    items,
    columns,
    resolvedState,
    selectedItems = [],
    keyField,
    actions = [],
    loading
  } = props

  function isDisableAction(action: GridAction<T>) {
    return isDisabled(action, disableFn => !some(items, x => !disableFn(x)))
  }

  function onHandleAll(action: GridAction<T>) {
    const { multipleHandler } = action
    const multipleItems = filter(
      items,
      x => !isDisabled(action, disableFn => disableFn(x))
    )
    if (multipleHandler)
      multipleHandler(multipleItems, columns, resolvedState, true)
  }

  function onHandleSelected(action: GridAction<T>) {
    const { multipleHandler } = action
    const selected = items.filter(item =>
      includes(selectedItems, item[keyField])
    )
    if (multipleHandler) multipleHandler(selected, columns, resolvedState)
  }

  // action.hide !== true cause hide supports function variant
  // in case of multiple object actions we interested only in boolean
  const multiActions = actions.filter(
    action => !!action.multipleHandler && action.hide !== true
  )
  if (isEmpty(multiActions)) return null
  return (
    <div className={styles.multiActions}>
      {multiActions.map((action, index) => (
        <MultiSelectAction
          key={index}
          template={action?.templateMultipleComponent}
          icon={action?.icon as any}
          iconType={action?.iconType}
          action={action}
          title={action.title}
          selectedItemsCount={selectedItems.length}
          disabled={loading || isDisableAction(action)}
          handleAll={onHandleAll}
          handleSelected={onHandleSelected}
        />
      ))}
    </div>
  )
}

export default ActionsPlugin
